<template>
    <div v-if="tableData.length > 0" class="card-table rounded-bottom mt-md-4">
        <el-table
        :data="tableData"
        show-index
        show-summary
        :summary-method="getSummaries"
        style="width: 100%">
            <el-table-column
                type="index"
                label="#"
                width="40"
            ></el-table-column>

            <el-table-column
                prop="case_recognize.created_at"
                label="Create Date"
                min-width="120"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.case_recognize">{{ scope.row.case_recognize.created_at | dateFormatString }}</span>
                </template>
            </el-table-column>

            <el-table-column
                prop="prod_customer_name"
                label="Customer Name"
                min-width="120"
            >
                <template slot-scope="scope">
                    <span class="text-break" v-if="scope.row.case">{{ scope.row.case.prod_customer_name }}</span>
                </template>
            </el-table-column>

            <el-table-column
                prop="comms_payout_summary_id"
                label="Comms Payout ID"
                min-width="90"
            >
                <template slot-scope="scope">
                    <span class="name"><a href="#" @click.prevent="openView(scope.row)">
                        #<span class="name text-primary">{{ scope.row.comms_payout_summary_id }}</span>
                    </a></span>
                </template>
            </el-table-column>

            <el-table-column
                prop="prod_type"
                label="Product Details"
                min-width="160"
                width="auto"
            >
                <template slot-scope="scope" v-if="scope.row.case && scope.row.case.prod_details">
                    <div>{{ scope.row.case.prod_type }}</div> 
                    <div class="name">{{ scope.row.case.prod_details.prod_pm_project_name }}</div> 
                    <div>{{ scope.row.case.prod_details.prod_pm_property_type }}</div> 
                    <div>{{ scope.row.case.prod_details.prod_pm_unit_no }} </div>
                </template>
            </el-table-column>

            <el-table-column
                prop="cps_develop_nett_price"
                label="Pre Sales (RM)"
                min-width="100"
                width="auto"
            >
                <template slot-scope="scope">
                    {{ scope.row.cps_develop_nett_price | moneyFormatter }}
                </template>
            </el-table-column>

            <el-table-column
                prop="cps_service_type_percentage"
                label="Comm. Rate(%)"
                min-width="80"
                width="auto"
            >
                <template slot-scope="scope">
                    <span class="text-break">{{ scope.row.cps_service_type_percentage }}</span>
                </template>
            </el-table-column>

            <el-table-column
                prop="cps_total_revenue_point"
                label="Pre Revenue.(RM)"
                min-width="120"
                width="auto"
            >
                <template slot-scope="scope">
                    {{ scope.row.cps_total_revenue_point | moneyFormatter }}
                </template>
            </el-table-column>

        </el-table>

        <PayoutDetailsModal 
            :showDirectPayoutDetails.sync="modals.showDirectPayoutDetails" 
            :current_comms_payout_summaries="current_view"
            :comms_payout_summaries="comms_payout_summaries"
            @close-modal="modals.showDirectPayoutDetails=false"
            :decide_mode="decide_mode"
            :permission="false"
        />
    </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useHubStore } from '@/stores/hubStore'
import PayoutDetailsModal from "@/views/Commission/Hub/HubProfile/CenterProfileDetails/PayoutDetailsModalV2";

export default {
    props: ['hub_id', 'hub_team_id', 'revenue_distribution_settings'],
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        PayoutDetailsModal,
    },
    data() {
        return {
            tableData: [],
            modals: {
                revenue_payout: false,
                revenue_pool: false,
                showDirectPayoutDetails: false,
            },
            total: [],
            current_view: [],
            decide_mode: false,
            comms_payout_summaries: [],
        }
    },
    computed: {
        ...mapState(useHubStore,['date_picked'])
    },
    watch: {
        async date_picked(newValue) {
            if(newValue)
            {
                const postData = {
                    'hub_id': this.hub_id,
                    'hub_team_id': this.hub_team_id,
                    'status': 'Pending',
                    'start_date': newValue[0],
                    'end_date': newValue[1],
                }

                try {
                    const res = await this.getCommsPayoutSummaryList(postData)
                    this.tableData = res.comms_payout_summaries
                    this.total = res.total
                } catch (error) {
                    // Handle any errors that might occur during the API call
                    console.error("Error fetching data:", error);
                }
            }
        },
    },
    async created() {
        const postData = {
            'hub_id': this.hub_id,
            'hub_team_id': this.hub_team_id,
            'start_date': this.date_picked[0] ?? null,
            'end_date': this.date_picked[1] ?? null,
            'status': 'Pending',
        }
        const res = await this.getCommsPayoutSummaryList(postData)
        this.tableData = res.comms_payout_summaries
        this.total = res.total
    },
    methods: {
        ...mapActions(useHubStore,['getCommsPayoutSummaryList']),
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 1) {
                    sums[index] = 'Total';
                    return;
                } else if (index === 5 || index === 7) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                        }, 0).toLocaleString(undefined, {maximumFractionDigits: 2});
                    } else {
                        sums[index] = 'N/A';
                    }
                }
            });

            return sums;
        },
        openView(row) {
            this.modals.showDirectPayoutDetails = true;
            this.current_view = row;
            this.comms_payout_summaries = [row];
        },
    }
}
</script>